export const HANDICAP_RANGE = {
  MIN: 0,
  MAX: 28
};

export const ROUTES = {
  HOME: '/',
  PLAYERS: '/players',
  MEMBERS: '/members',
  PLAYER_DETAIL: '/players/:id',
  COURSES: '/courses',
  CALCULATOR: '/calculator',
  NEW_ROUND: '/rounds/new',
  CREATE_EVENT: '/events/new',
  EVENTS: '/events',
  ROUND_SETUP: '/rounds/:id/setup',
  ACTIVE_ROUND: '/rounds/:id',
  HISTORY: '/history',
  LEADERBOARD: '/leaderboard',
  SCORING: '/scoring',

  // The Clubhouse — neutral shell for guest ('open') events
  CLUBHOUSE_HOME: '/clubhouse',
  CLUBHOUSE_ROUNDS: '/clubhouse/rounds',
  CLUBHOUSE_SCORING: '/clubhouse/scoring',

  // FriDave Super Series
  FRIDAVE_HOME: '/fridave',
  FRIDAVE_ROUNDS: '/fridave/rounds',
  FRIDAVE_CREATE: '/fridave/rounds/new',
  FRIDAVE_SCORING: '/fridave/scoring',
  FRIDAVE_STANDINGS: '/fridave/standings',
  FRIDAVE_STATS: '/fridave/stats',
};

export const COLORS = {
  PRIMARY: '#1a472a',
  SECONDARY: '#2d6a4f',
  ACCENT: '#40916c',
  SUCCESS: '#52b788',
  WARNING: '#f4a261',
  ERROR: '#e76f51'
};
